(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-bespoke-brief"] && !Shopify.designMode) return;
  try {
    
  /**
   * The folded steps of the commission brief.
   *
   * One step open at a time, a précis of the answers on every shut row, and — the part that
   * matters — any step still holding something required springs open the moment a submission is
   * refused. A required field hidden inside a closed drawer is the one way an accordion can make
   * a form worse, so the accordion gets out of the way rather than being argued with.
   *
   * Exclusivity is driven from the summary's click rather than from `toggle`, because `toggle`
   * fires asynchronously: opening five drawers in a loop queues five events that then race, and
   * the last one to arrive closes the other four. A click is the only moment we actually know a
   * person asked for a step, which is the only moment the others should shut.
   */
  class LMBriefSteps extends HTMLElement {
    static REQUIRED = {
      2: ['#Brief-date', '#Brief-zip'],
      5: ['#Brief-notes'],
      6: ['[data-brief-name]', '[data-brief-email]'],
    };

    connectedCallback() {
      this.folds = [...this.querySelectorAll('details[data-brief-fold]')];
      if (!this.folds.length) return;

      this.folds.forEach((fold) => {
        const summary = fold.querySelector('summary');
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          const opening = !fold.open;
          this.folds.forEach((other) => { other.open = false; });
          fold.open = opening;
        });
      });

      // The first question is answered outside the accordion; answering it opens the second.
      this.querySelectorAll('[data-brief-piece]').forEach((input) => {
        input.addEventListener('change', () => this.reveal('2'));
      });

      this.addEventListener('input', () => this.paint());
      this.addEventListener('change', () => this.paint());

      const missing = this.querySelector('[data-brief-missing]');
      if (missing) {
        new MutationObserver(() => { if (!missing.hidden) this.openGaps(); })
          .observe(missing, { attributes: true, attributeFilter: ['hidden'] });
      }

      this.paint();
    }

    field(sel) {
      return (this.querySelector(sel)?.value || '').trim();
    }

    reveal(name) {
      const fold = this.folds.find((f) => f.dataset.briefFold === name);
      if (!fold) return;
      this.folds.forEach((other) => { if (other !== fold) other.open = false; });
      fold.open = true;
    }

    /* Open every step that is still missing something, and nothing else: being refused is no
       reason to unroll the four steps that were already answered. */
    openGaps() {
      let opened = 0;
      this.folds.forEach((fold) => {
        const wanted = LMBriefSteps.REQUIRED[fold.dataset.briefFold] || [];
        if (wanted.some((sel) => !this.field(sel))) {
          fold.open = true;
          opened += 1;
        }
      });
      if (!opened) this.folds.forEach((fold) => { fold.open = true; });
    }

    paint() {
      const join = (parts) => parts.filter(Boolean).join(' · ');
      const clip = (text, n) => (text.length > n ? `${text.slice(0, n - 1)}…` : text);
      const colours = (this.querySelector('[data-brief-colours]')?.value || '').split(', ').filter(Boolean);
      const images = this.querySelectorAll('[data-brief-thumbs] li').length;

      const precis = {
        2: join([this.field('#Brief-occasion'), this.field('#Brief-date'), this.field('#Brief-zip')]),
        3: join([
          colours.length
            ? colours.slice(0, 3).join(', ') + (colours.length > 3 ? ` +${colours.length - 3}` : '')
            : '',
          this.field('#Brief-colournotes'),
          images ? `${images} image${images > 1 ? 's' : ''}` : '',
        ]),
        4: join([this.field('#Brief-count'), this.field('#Brief-budget')]),
        5: clip(join([this.field('#Brief-wording'), this.field('#Brief-notes')]), 60),
        6: join([this.field('#Brief-name'), this.field('#Brief-email')]),
      };

      this.querySelectorAll('[data-brief-precis]').forEach((el) => {
        el.textContent = precis[el.dataset.briefPrecis] || '';
      });
    }
  }

  if (!customElements.get('lm-brief-steps')) customElements.define('lm-brief-steps', LMBriefSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-bespoke-chapters"] && !Shopify.designMode) return;
  try {
    
  /*
    One chapter open at a time. The film inside a chapter is fetched the first time that chapter is
    opened and paused whenever it closes, so an unopened chapter costs nothing.
  */
  class LMChapters extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details.lm-chapter'));
      this.items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) this.onOpen(item);
          else this.pause(item);
        });
      });
      const open = this.items.find((item) => item.open);
      if (open) this.play(open);
    }

    onOpen(item) {
      this.items.forEach((other) => {
        if (other !== item && other.open) other.open = false;
      });
      this.play(item);
      // Opening a chapter collapses the one above it, which can pull the row off screen.
      requestAnimationFrame(() => {
        const top = item.getBoundingClientRect().top;
        const header = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--lm-header-height')
        ) || 72;
        if (top < header) {
          window.scrollTo({ top: window.scrollY + top - header - 16, behavior: 'smooth' });
        }
      });
    }

    play(item) {
      const video = item.querySelector('.lm-chapter__video');
      if (!video) return;
      if (!video.src && video.dataset.src) {
        video.src = video.dataset.src;
        video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      }
      const go = video.play();
      if (go && go.catch) go.catch(() => {});
    }

    pause(item) {
      const video = item.querySelector('.lm-chapter__video');
      if (video && video.src) video.pause();
    }
  }

  if (!customElements.get('lm-chapters')) customElements.define('lm-chapters', LMChapters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-collection-columns"] && !Shopify.designMode) return;
  try {
    
  /* A doorway may carry a film. Fetched only when the row nears the viewport, paused off screen. */
  class LmCollectionColumns extends HTMLElement {
    connectedCallback() {
      const films = Array.from(this.querySelectorAll('.lm-collection-columns__film'));
      if (!films.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const start = (film) => {
        if (!film.getAttribute('src')) {
          film.src = film.dataset.src;
          film.preload = 'auto';
        }
        film
          .play()
          .then(() => film.classList.add('is-playing'))
          .catch(() => {
            window.addEventListener('pointerdown', () => start(film), { once: true, passive: true });
          });
      };

      if (!('IntersectionObserver' in window)) {
        films.forEach(start);
        return;
      }
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) start(entry.target);
            else entry.target.pause();
          });
        },
        { rootMargin: '300px 0px', threshold: 0.1 }
      );
      films.forEach((film) => this.io.observe(film));
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }
  }

  if (!customElements.get('lm-collection-columns')) {
    customElements.define('lm-collection-columns', LmCollectionColumns);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-collection-hero"] && !Shopify.designMode) return;
  try {
    
  /* The band's film is fetched only when the band is near the viewport, and only when motion is
     allowed. Until then the still carries it, which is also what reduced-motion visitors keep. */
  class LmCollectionHero extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.slides();

      const film = this.querySelector('.lm-collection-hero__film');
      if (!film || !film.dataset.src) return;

      let armed = false;
      /* Autoplay can still be refused before the visitor has touched the page. Rather than fall
         back to the still for good, wait for the first gesture and try again — the same retry the
         homepage hero uses. */
      const arm = () => {
        if (armed) return;
        armed = true;
        const kick = () => { armed = false; start(); };
        ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach((e) =>
          window.addEventListener(e, kick, { once: true, passive: true }));
      };

      const start = () => {
        if (!film.getAttribute('src')) {
          film.src = film.dataset.src;
          film.preload = 'auto';
        }
        film.play().then(() => film.classList.add('is-playing')).catch(arm);
      };

      if (!('IntersectionObserver' in window)) { start(); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) start();
          else film.pause();
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 });
      io.observe(this);
    }

    /* Two photographs turn over slowly, and only while the band is on screen. */
    slides() {
      const slide = this.querySelector('[ref="slide"]');
      if (!slide) return;
      const dwell = parseInt(this.dataset.dwell, 10) || 5000;
      const turn = () => slide.classList.toggle('is-showing');

      if (!('IntersectionObserver' in window)) {
        this.timer = window.setInterval(turn, dwell);
        return;
      }
      this.slideIo = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) this.timer ||= window.setInterval(turn, dwell);
          else if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }
        },
        { threshold: 0.2 }
      );
      this.slideIo.observe(this);
    }

    disconnectedCallback() {
      this.slideIo?.disconnect();
      if (this.timer) window.clearInterval(this.timer);
    }
  }

  if (!customElements.get('lm-collection-hero')) {
    customElements.define('lm-collection-hero', LmCollectionHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-edit-film"] && !Shopify.designMode) return;
  try {
    
  class LmEditFilm extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[ref="video"]');
      if (!this.video) return;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduced.matches) return;

      this.toggle = this.querySelector('[ref="toggle"]');
      this.fill = this.querySelector('[ref="fill"]');
      this.barA = this.querySelector('[ref="barA"]');
      this.barB = this.querySelector('[ref="barB"]');
      this.wanted = true;
      this.armed = false;

      this.toggle?.addEventListener('click', () => {
        this.wanted = !this.wanted;
        if (this.wanted) this.play();
        else {
          this.video.pause();
          this.paint();
        }
      });

      this.video.addEventListener('timeupdate', () => this.tick());
      this.video.addEventListener('play', () => this.paint());
      this.video.addEventListener('pause', () => this.paint());

      /* The film is the head of the page, so it starts straight away — but it is paused whenever
         it scrolls away, which keeps a long edit page from decoding video nobody is looking at. */
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) this.play();
            else this.video.pause();
          },
          { threshold: 0.05 }
        );
        this.io.observe(this);
      }
      this.play();
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }

    play() {
      if (!this.wanted) return;
      this.video
        .play()
        .then(() => {
          this.video.classList.add('is-playing');
          this.paint();
        })
        .catch(() => this.arm());
    }

    /* Autoplay can be refused until the visitor has touched the page. Wait for the first gesture
       and try again rather than settling for the still. */
    arm() {
      if (this.armed) return;
      this.armed = true;
      const kick = () => {
        this.armed = false;
        this.play();
      };
      ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach((name) =>
        window.addEventListener(name, kick, { once: true, passive: true })
      );
    }

    tick() {
      if (!this.fill || !this.video.duration) return;
      this.fill.style.width = `${(this.video.currentTime / this.video.duration) * 100}%`;
    }

    /* The two bars of the pause mark slide together into the triangle of a play mark. */
    paint() {
      if (!this.barA || !this.barB || !this.toggle) return;
      const paused = this.video.paused;
      this.toggle.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
      if (paused) {
        this.barA.setAttribute('x', '4');
        this.barA.setAttribute('y', '2');
        this.barA.setAttribute('width', '2');
        this.barA.setAttribute('height', '12');
        this.barB.setAttribute('x', '6');
        this.barB.setAttribute('y', '4.4');
        this.barB.setAttribute('width', '2');
        this.barB.setAttribute('height', '7.2');
      } else {
        this.barA.setAttribute('x', '3');
        this.barA.setAttribute('y', '2');
        this.barA.setAttribute('width', '3.4');
        this.barA.setAttribute('height', '12');
        this.barB.setAttribute('x', '9.6');
        this.barB.setAttribute('y', '2');
        this.barB.setAttribute('width', '3.4');
        this.barB.setAttribute('height', '12');
      }
    }
  }

  if (!customElements.get('lm-edit-film')) customElements.define('lm-edit-film', LmEditFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-edit-header"] && !Shopify.designMode) return;
  try {
    
  class LmEditHeader extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[ref="nav"]');
      this.sentinel = this.querySelector('[ref="sentinel"]');
      this.items = Array.from(this.querySelectorAll('.lm-edit-header__item'));
      if (!this.nav || !this.sentinel) return;

      // Reserve the row's height before it detaches, so nothing jumps when it goes sticky.
      this.stick = new IntersectionObserver(
        ([entry]) => {
          const stuck = entry ? entry.boundingClientRect.bottom < (entry.rootBounds?.top ?? 0) : false;
          this.classList.toggle('lm-edit-header--stuck', stuck);
          this.nav.style.height = '';
          if (stuck) this.style.paddingBottom = `${this.nav.offsetHeight}px`;
          else this.style.paddingBottom = '';
        },
        { rootMargin: `-${this.headerOffset()}px 0px 0px 0px`, threshold: 0 }
      );
      this.stick.observe(this.sentinel);

      this.jumpToSections();
      this.trackSections();
    }

    disconnectedCallback() {
      this.stick?.disconnect();
      this.spy?.disconnect();
    }

    /**
     * Every collection on this page already has its block here, so the row scrolls to it
     * instead of reloading. A link whose block is not on this page is left to navigate.
     */
    jumpToSections() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      for (const item of this.items) {
        const link = item.querySelector('a[data-anchor]');
        if (!link) continue;
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
          const target = document.getElementById(link.dataset.anchor);
          if (!target) return;
          event.preventDefault();
          const offset = this.headerOffset() + (this.nav?.offsetHeight || 0);
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
          history.replaceState(null, '', `#${link.dataset.anchor}`);
        });
      }
    }

    headerOffset() {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--lm-header-height');
      return parseInt(value, 10) || 72;
    }

    /** Marks whichever collection block is currently in view. */
    trackSections() {
      const targets = this.items
        .map((item) => {
          const id = item.querySelector('[data-anchor]')?.dataset.anchor;
          return id ? { item, el: document.getElementById(id) } : null;
        })
        .filter((entry) => entry && entry.el);
      if (!targets.length) return;

      this.spy = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const match = targets.find((t) => t.el === entry.target);
            if (!match) continue;
            this.items.forEach((item) => item.classList.toggle('is-current', item === match.item));
          }
        },
        { rootMargin: `-${this.headerOffset() + 80}px 0px -55% 0px` }
      );
      targets.forEach((t) => this.spy?.observe(t.el));
    }
  }

  if (!customElements.get('lm-edit-header')) customElements.define('lm-edit-header', LmEditHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-edits"] && !Shopify.designMode) return;
  try {
    
  /**
   * Lazily attaches band videos. The file is only requested once the band is near the viewport,
   * so it never competes with the first screen. Under prefers-reduced-motion nothing is loaded
   * at all and the still image carries the band.
   */
  class LmEdits extends HTMLElement {
    connectedCallback() {
      this.startSlideshows();

      this.videos = Array.from(this.querySelectorAll('.lm-edit__video'));
      if (!this.videos.length) return;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduced.matches) return;

      if (!('IntersectionObserver' in window)) {
        this.videos.forEach((video) => this.load(video));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this.load(/** @type {HTMLVideoElement} */ (entry.target));
            this.observer?.unobserve(entry.target);
          }
        },
        { rootMargin: '400px 0px' }
      );
      this.videos.forEach((video) => this.observer?.observe(video));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.slideObserver?.disconnect();
      this.timers?.forEach((id) => window.clearInterval(id));
    }

    /**
     * Cross-fades any tile that lists several slides. The timer starts only once the tile reaches
     * the viewport, so an off-screen band isn't cycling for nobody. Under reduced motion the tile
     * holds on its first slide.
     */
    startSlideshows() {
      const tiles = Array.from(this.querySelectorAll('[data-slide-seconds]'));
      if (!tiles.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.timers = [];
      const run = (tile) => {
        const slides = Array.from(tile.querySelectorAll('.lm-edit__slide'));
        if (slides.length < 2) return;
        const every = (parseFloat(tile.dataset.slideSeconds) || 5) * 1000;
        let index = 0;
        this.timers.push(
          window.setInterval(() => {
            slides[index].classList.remove('is-active');
            index = (index + 1) % slides.length;
            slides[index].classList.add('is-active');
          }, every)
        );
      };

      if (!('IntersectionObserver' in window)) {
        tiles.forEach(run);
        return;
      }
      this.slideObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            run(/** @type {HTMLElement} */ (entry.target));
            this.slideObserver?.unobserve(entry.target);
          }
        },
        { rootMargin: '200px 0px' }
      );
      tiles.forEach((tile) => this.slideObserver?.observe(tile));
    }

    /** @param {HTMLVideoElement} video */
    load(video) {
      if (video.dataset.loaded) return;
      video.dataset.loaded = 'true';

      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const src = (mobile && video.dataset.srcMobile) || video.dataset.src;
      if (!src) return;

      const reveal = () => video.classList.add('is-playing');
      video.addEventListener('playing', reveal, { once: true });
      video.addEventListener(
        'canplay',
        () => {
          video.play().then(reveal).catch(() => {});
        },
        { once: true }
      );

      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.append(source);
      video.load();
    }
  }

  if (!customElements.get('lm-edits')) customElements.define('lm-edits', LmEdits);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-framed-film"] && !Shopify.designMode) return;
  try {
    
  class LmFramedFilm extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[ref="video"]');
      if (!this.video) return;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduced.matches) return;

      this.toggle = this.querySelector('[ref="toggle"]');
      this.barA = this.querySelector('[ref="barA"]');
      this.barB = this.querySelector('[ref="barB"]');
      this.wanted = true;
      this.armed = false;

      this.toggle?.addEventListener('click', () => {
        this.wanted = !this.wanted;
        if (this.wanted) this.play();
        else {
          this.video.pause();
          this.paint();
        }
      });
      this.video.addEventListener('play', () => this.paint());
      this.video.addEventListener('pause', () => this.paint());

      if ('IntersectionObserver' in window) {
        /*
         * Two observers. The outer one fetches the film well before it is needed, so it is
         * buffered by the time anyone can see it. The inner one runs it only once it is actually
         * on screen, and rewinds first — these films open on a held frame and then move, and a
         * film that resumed halfway through would never show its own opening.
         */
        this.loadIo = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            this.load();
            this.loadIo.disconnect();
          },
          { rootMargin: '700px 0px' }
        );
        this.loadIo.observe(this);

        this.io = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) this.play(true);
            else this.video.pause();
          },
          { threshold: 0.2 }
        );
        this.io.observe(this);
      } else {
        this.play();
      }
    }

    disconnectedCallback() {
      this.io?.disconnect();
      this.loadIo?.disconnect();
    }

    load() {
      if (this.video.getAttribute('src')) return;
      this.video.src = this.video.dataset.src;
      this.video.preload = 'auto';
    }

    play(fromStart) {
      if (!this.wanted) return;
      this.load();
      if (fromStart && this.video.paused && this.video.currentTime > 0.05) {
        try {
          this.video.currentTime = 0;
        } catch (error) {
          /* a browser that will not seek before metadata arrives simply plays on */
        }
      }
      this.video
        .play()
        .then(() => {
          this.video.classList.add('is-playing');
          this.paint();
        })
        .catch(() => this.arm());
    }

    arm() {
      if (this.armed) return;
      this.armed = true;
      const kick = () => {
        this.armed = false;
        this.play();
      };
      ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach((name) =>
        window.addEventListener(name, kick, { once: true, passive: true })
      );
    }

    /* The two bars of the pause mark close into the triangle of a play mark. */
    paint() {
      if (!this.barA || !this.barB || !this.toggle) return;
      const paused = this.video.paused;
      this.toggle.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
      const a = paused ? ['4', '2', '2', '12'] : ['3', '2', '3.4', '12'];
      const b = paused ? ['6', '4.4', '2', '7.2'] : ['9.6', '2', '3.4', '12'];
      ['x', 'y', 'width', 'height'].forEach((name, i) => {
        this.barA.setAttribute(name, a[i]);
        this.barB.setAttribute(name, b[i]);
      });
    }
  }

  if (!customElements.get('lm-framed-film')) customElements.define('lm-framed-film', LmFramedFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-header"]) return;
  try {
    
  class LmHeader extends HTMLElement {
    constructor() {
      super();
      this.bar = this.querySelector('[ref="bar"]');
      this.drawer = this.querySelector('[ref="drawer"]');
      this.burger = this.querySelector('[ref="burger"]');
      this.closeButton = this.querySelector('[ref="closeDrawer"]');
      this.pageWrapper = document.querySelector('.page-wrapper');
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.resizeObserver.observe(this.bar);
      this.updateHeight();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.pageWrapper?.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateScrolled();

      this.burger?.addEventListener('click', () => {
        this.showLevel?.('root');
        this.openDrawer();
      });
      this.closeButton?.addEventListener('click', () => this.closeDrawer());
      this.drawer?.addEventListener('click', (event) => {
        if (event.target === this.drawer) this.closeDrawer();
      });
      this.drawer?.addEventListener('close', () => {
        this.burger?.setAttribute('aria-expanded', 'false');
      });
      this.drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.closeDrawer()));

      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.desktopQuery.addEventListener('change', () => {
        if (this.desktopQuery.matches) this.closeDrawer();
        this.closePanel();
      });

      this.setupPanels();
      this.setupSheet();
      this.setupSearchHint();
    }

    /* The phone search field names a real piece, changing every few seconds, so the field reads
       as an invitation rather than an empty box. */
    setupSearchHint() {
      const hint = this.querySelector('[ref="searchHint"]');
      if (!hint) return;
      const list = (hint.dataset.suggestions || '')
        .split(/\r?\n|\\n/)
        .map((line) => line.trim())
        .filter(Boolean);
      if (!list.length) return;

      let i = 0;
      const show = () => { hint.textContent = `Search for ${list[i % list.length]}`; };
      show();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.hintTimer = setInterval(() => {
        hint.classList.add('is-fading');
        setTimeout(() => { i += 1; show(); hint.classList.remove('is-fading'); }, 340);
      }, 3600);
    }

    /* ---------------------------------------------------------------- drop-down band */
    setupPanels() {
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.triggers = [...this.querySelectorAll('[data-menu]')];
      this.dim = this.querySelector('[ref="dim"]');
      if (!this.panels.length) return;
      this.openId = null;

      for (const trigger of this.triggers) {
        trigger.addEventListener('click', () => {
          this.openId === trigger.dataset.menu ? this.closePanel() : this.openPanel(trigger.dataset.menu);
        });
        trigger.addEventListener('mouseenter', () => {
          if (this.desktopQuery.matches) {
            clearTimeout(this.shutTimer);
            this.openPanel(trigger.dataset.menu);
          }
        });
      }

      /* The pointer is tracked on the document rather than the header, because the scrim is a
         child of the header: moving down onto the page lands on the scrim, which mouseleave would
         still count as being inside. A short grace period covers the seam between word and panel. */
      this.onPointerOver = (event) => {
        if (!this.openId || !this.desktopQuery.matches) return;
        const panel = this.querySelector('.lm-header__panel.is-open');
        const inside = Boolean(this.bar?.contains(event.target) || panel?.contains(event.target));
        this.pointerInsideMenu = inside;
        clearTimeout(this.shutTimer);
        if (inside) return;
        this.shutTimer = setTimeout(() => this.closePanel(), 120);
      };
      document.addEventListener('pointerover', this.onPointerOver);
      /* Leaving the window altogether fires no pointerover. */
      document.addEventListener('mouseleave', () => this.closePanel());
      this.dim?.addEventListener('click', () => this.closePanel());

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.openId) return;
        const trigger = this.triggers.find((t) => t.dataset.menu === this.openId);
        this.closePanel();
        trigger?.focus();
      });

      /* Leaving the panel by keyboard closes it, so Tab does not run on into a hidden menu. */
      this.addEventListener('focusout', (event) => {
        if (!this.openId) return;
        if (!this.contains(event.relatedTarget)) this.closePanel();
      });

      for (const panel of this.panels) {
        const reel = panel.querySelector('[data-reel]');
        const prev = panel.querySelector('[data-reel-prev]');
        const next = panel.querySelector('[data-reel-next]');
        if (!reel) continue;
        const sync = () => {
          const over = reel.scrollWidth - reel.clientWidth > 8;
          if (prev) prev.hidden = !over || reel.scrollLeft < 8;
          if (next) next.hidden = !over || reel.scrollLeft > reel.scrollWidth - reel.clientWidth - 8;
        };
        prev?.addEventListener('click', () => reel.scrollBy({ left: -reel.clientWidth * 0.8, behavior: 'smooth' }));
        next?.addEventListener('click', () => reel.scrollBy({ left: reel.clientWidth * 0.8, behavior: 'smooth' }));
        reel.addEventListener('scroll', sync);
        panel._syncReel = sync;
      }
    }

    openPanel(id) {
      if (!this.desktopQuery?.matches) return;
      for (const panel of this.panels) {
        const match = panel.dataset.panel === id;
        panel.hidden = false;
        panel.classList.toggle('is-open', match);
        if (match) panel._syncReel?.();
      }
      for (const trigger of this.triggers) {
        trigger.setAttribute('aria-expanded', String(trigger.dataset.menu === id));
      }
      if (this.dim) {
        this.dim.hidden = false;
        /* Flush the unhidden state so the fade has somewhere to start; a rAF here is skipped
           entirely when the tab is in the background, which leaves the scrim stuck invisible. */
        void this.dim.offsetWidth;
        this.dim.classList.add('is-open');
      }
      this.openId = id;
    }

    closePanel() {
      if (!this.panels?.length) return;
      this.pointerInsideMenu = false;
      for (const panel of this.panels) panel.classList.remove('is-open');
      for (const trigger of this.triggers) trigger.setAttribute('aria-expanded', 'false');
      this.dim?.classList.remove('is-open');
      this.openId = null;
    }

    /* ---------------------------------------------------------------- phone sheet */
    setupSheet() {
      this.sheet = this.querySelector('[data-sheet]');
      if (!this.sheet) return;
      this.levels = [...this.sheet.querySelectorAll('[data-level]')];
      this.backButton = this.querySelector('[ref="back"]');
      this.drawerCrest = this.querySelector('[ref="drawerCrest"]');
      this.drawerTitle = this.querySelector('[ref="drawerTitle"]');
      this.trail = [];

      this.sheet.addEventListener('click', (event) => {
        const go = event.target.closest('[data-go]');
        if (!go) return;
        this.trail.push(this.currentLevel || 'root');
        this.showLevel(go.dataset.go);
      });
      this.backButton?.addEventListener('click', () => this.showLevel(this.trail.pop() || 'root'));
      this.showLevel('root');
    }

    showLevel(id) {
      this.currentLevel = id;
      if (id === 'root') this.trail = [];
      for (const level of this.levels) {
        const match = level.dataset.level === id;
        level.hidden = !match;
        level.classList.toggle('is-current', match);
      }
      const level = this.levels.find((l) => l.dataset.level === id);
      const root = id === 'root';
      if (this.backButton) this.backButton.hidden = root;
      if (this.drawerCrest) this.drawerCrest.hidden = !root;
      if (this.drawerTitle) {
        this.drawerTitle.hidden = root;
        this.drawerTitle.textContent = root ? '' : level?.dataset.title || '';
      }
      this.sheet.scrollTop = 0;
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      clearInterval(this.hintTimer);
      clearTimeout(this.shutTimer);
      if (this.onPointerOver) document.removeEventListener('pointerover', this.onPointerOver);
      window.removeEventListener('scroll', this.onScroll);
      this.pageWrapper?.removeEventListener('scroll', this.onScroll);
    }

    updateHeight() {
      const height = Math.round(this.bar.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--lm-header-height', `${height}px`);
    }

    scrollTop() {
      return Math.max(this.pageWrapper?.scrollTop ?? 0, window.scrollY, document.documentElement.scrollTop);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.updateScrolled();
        /* Only a scroll made away from the menu closes it. A trackpad gesture over the reel has a
           vertical component more often than not, and that should move the photographs, not shut
           the panel. */
        if (this.openId && !this.pointerInsideMenu) this.closePanel();
      });
    }

    updateScrolled() {
      this.dataset.scrolled = this.scrollTop() > 40 ? 'true' : 'false';
    }

    openDrawer() {
      if (!this.drawer || this.drawer.open) return;
      this.drawer.showModal();
      this.burger?.setAttribute('aria-expanded', 'true');
      this.closeButton?.focus();
    }

    closeDrawer() {
      if (!this.drawer?.open) return;
      this.drawer.close();
      this.burger?.focus();
    }
  }

  if (!customElements.get('lm-header')) customElements.define('lm-header', LmHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-hero"] && !Shopify.designMode) return;
  try {
    
  const LM_HERO_ICON = {
    play: '<svg viewBox="0 0 11 12" aria-hidden="true"><path d="M0 0l11 6-11 6z"/></svg>',
    pause:
      '<svg viewBox="0 0 11 12" aria-hidden="true"><rect x="0" y="0" width="3.6" height="12"/><rect x="7.4" y="0" width="3.6" height="12"/></svg>',
  };

  class LmHero extends HTMLElement {
    connectedCallback() {
      const cfgEl = this.querySelector('[data-hero-config]');
      if (!cfgEl) return;
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch (_) {
        return;
      }
      if (!this.cfg.length) return;

      this.slides = [...this.querySelectorAll('.lm-hero__slide')];
      this.chips = [...this.querySelectorAll('[data-chip]')];
      this.swap = this.querySelector('[data-swap]');
      this.elTitle = this.querySelector('[data-title]');
      this.elLine = this.querySelector('[data-line]');
      this.elCta = this.querySelector('[data-cta]');
      this.elFill = this.querySelector('[data-fill]');
      this.elNow = this.querySelector('[data-now]');
      this.elScrim = this.querySelector('[data-scrim]');
      this.pp = this.querySelector('[data-pp]');

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.cur = 0;
      this.playing = !this.reduced.matches;
      this.armed = false;

      this.chips.forEach((c) =>
        c.addEventListener('click', () => this.go(Number(c.dataset.chip), true))
      );

      this.slides.forEach((slide, i) => {
        const v = slide.querySelector('video');
        if (!v) return;
        v.addEventListener('timeupdate', () => {
          if (i !== this.cur || !v.duration || !this.elFill) return;
          this.elFill.style.width = ((v.currentTime / v.duration) * 100).toFixed(2) + '%';
        });
        v.addEventListener('ended', () => {
          if (i === this.cur && this.playing) this.go(this.cur + 1);
        });
      });

      if (this.pp) {
        this.pp.innerHTML = this.playing ? LM_HERO_ICON.pause : LM_HERO_ICON.play;
        this.pp.addEventListener('click', () => {
          this.playing = !this.playing;
          this.pp.innerHTML = this.playing ? LM_HERO_ICON.pause : LM_HERO_ICON.play;
          this.pp.setAttribute('aria-label', this.playing ? 'Pause the hero' : 'Play the hero');
          const v = this.video(this.cur);
          if (!v) return;
          if (this.playing) this.tryPlay();
          else v.pause();
        });
      }

      // Only start once the hero is actually on screen, and stop when the tab is hidden.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) this.tryPlay();
            else this.video(this.cur)?.pause();
          });
        }, { threshold: 0.15 }).observe(this);
      }
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') this.tryPlay();
        else this.video(this.cur)?.pause();
      });

      if (!this.reduced.matches) {
        this.load(0);
        this.tryPlay();
        this.load(1);
      }
    }

    video(i) {
      return this.slides[i]?.querySelector('video') || null;
    }

    load(i) {
      const n = ((i % this.slides.length) + this.slides.length) % this.slides.length;
      const v = this.video(n);
      if (!v) return null;
      if (!v.getAttribute('src') && v.dataset.src) {
        v.src = v.dataset.src;
        v.preload = 'auto';
      }
      return v;
    }

    /* Autoplay is refused often enough — a cold tab, low power mode, a strict setting — that
       giving up on the first rejection would leave the hero sitting on a still. Keep the intent
       to play and take the next thing the visitor does as permission to start. */
    tryPlay() {
      if (!this.playing || this.reduced.matches) return;
      const v = this.load(this.cur);
      if (!v) return;
      v.play()
        .then(() => {
          v.classList.add('is-playing');
          if (this.pp) this.pp.innerHTML = LM_HERO_ICON.pause;
        })
        .catch(() => this.arm());
    }

    arm() {
      if (this.armed) return;
      this.armed = true;
      const kick = () => {
        this.armed = false;
        this.tryPlay();
      };
      ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach((e) =>
        window.addEventListener(e, kick, { once: true, passive: true })
      );
    }

    go(i, manual) {
      const n = ((i % this.cfg.length) + this.cfg.length) % this.cfg.length;
      if (n === this.cur && manual) return;
      const prev = this.cur;
      this.cur = n;

      if (prev !== n) this.video(prev)?.pause();

      this.slides.forEach((el, k) => el.classList.toggle('is-on', k === n));
      this.chips.forEach((el, k) => {
        el.classList.toggle('is-on', k === n);
        el.setAttribute('aria-selected', k === n ? 'true' : 'false');
      });
      if (this.elNow) this.elNow.textContent = String(n + 1);
      if (this.elFill) this.elFill.style.width = '0%';
      if (this.elScrim) this.elScrim.style.setProperty('--lm-scrim', this.cfg[n].scrim);

      if (this.swap) {
        this.swap.classList.add('is-out');
        clearTimeout(this.swapTimer);
        this.swapTimer = setTimeout(() => {
          this.writeCopy();
          this.swap.classList.remove('is-out');
        }, 300);
      } else {
        this.writeCopy();
      }

      if (this.reduced.matches) return;
      const v = this.load(n);
      if (!v) return;
      try {
        v.currentTime = 0;
      } catch (_) {}
      const reveal = () => v.classList.add('is-playing');
      if (v.readyState >= 2) reveal();
      else v.addEventListener('loadeddata', reveal, { once: true });
      if (this.playing) this.tryPlay();
      this.load(n + 1);
    }

    writeCopy() {
      const s = this.cfg[this.cur];
      if (this.elTitle) this.elTitle.textContent = s.title || '';
      if (this.elLine) {
        this.elLine.textContent = s.line || '';
        this.elLine.hidden = !s.line;
      }
      if (this.elCta) {
        this.elCta.textContent = s.cta || '';
        this.elCta.href = s.href || '#';
      }
    }
  }

  if (!customElements.get('lm-hero')) customElements.define('lm-hero', LmHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-immersive-hero"] && !Shopify.designMode) return;
  try {
    
  /* Writes the scroll progress of the pinned frame onto the element as --p (the scrim and the
     copy, which finish before the pin releases) and --q (the slow scale, which runs the whole
     way). Nothing animates on a timer, so there is no drift and no work when the hero is off
     screen. */
  class LmImmersiveHero extends HTMLElement {
    connectedCallback() {
      this.run = this.querySelector('.lm-ih__run');
      if (!this.run) return;

      this.img = this.querySelector('.lm-ih__img');
      this.fill = parseFloat(this.dataset.fill) || 1.5;
      this.fit();
      if (this.img && !this.img.complete) this.img.addEventListener('load', () => this.fit(), { once: true });

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduced.matches) {
        /* Still a close-up; just no scroll work. */
        addEventListener('resize', () => this.fit(), { passive: true });
        return;
      }

      this.ticking = false;
      this.visible = true;
      this.onScroll = () => {
        if (this.ticking || !this.visible) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.fit();
          this.measure();
        });
      };

      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll, { passive: true });

      /* Stop measuring once the hero has left the viewport entirely. */
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.measure();
        });
        this.io.observe(this.run);
      }

      this.reduced.addEventListener('change', () => {
        if (!this.reduced.matches) return;
        this.style.removeProperty('--p');
        this.style.removeProperty('--q');
      });

      this.measure();
    }

    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
      this.io?.disconnect();
    }

    /* Scale the image so it is always --fill times the frame wide, whatever shape the frame is.
       object-fit: cover already enlarges a portrait image inside a tall narrow frame, so without
       this a phone would crop several times harder than a desktop and cut the piece to pieces. */
    fit() {
      const pin = this.querySelector('.lm-ih__pin');
      if (!pin || !this.img) return;
      const w = pin.offsetWidth;
      const h = pin.offsetHeight;
      const ri = (this.img.naturalWidth || 3) / (this.img.naturalHeight || 4);
      if (!w || !h) return;
      const covered = Math.max(1, ri / (w / h)); /* how much wider than the frame cover already is */
      /* A frame tall enough that cover alone overshoots --fill would otherwise sit at plain
         cover and read as a product shot; the floor keeps a phone a close-up too. */
      this.style.setProperty('--zoom', Math.max(1.15, this.fill / covered).toFixed(4));

      /* A phone is so much narrower than the art that cover crops past the asked-for close-up on
         its own; where that would cut the lettering, the frame is given a second focal point. */
      const narrow = this.dataset.focusNarrow;
      if (narrow) {
        if (w / h < 0.62) this.style.setProperty('--focus-now', narrow);
        else this.style.removeProperty('--focus-now');
      }
    }

    /* Exposed so the harness can drive progress without a real scroll. */
    measure() {
      const rect = this.run.getBoundingClientRect();
      const travel = rect.height - (this.querySelector('.lm-ih__pin')?.offsetHeight || innerHeight);
      const q = travel > 0 ? Math.min(Math.max(-rect.top / travel, 0), 1) : 0;
      /* The copy is fully in with scroll still to spare, so it is readable before the pin lets go. */
      const t = Math.min(q / 0.62, 1);
      const p = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      /* Clear over the last of the run so the frame hands over to the grid bright. */
      const out = Math.min(Math.max((q - 0.86) / 0.14, 0), 1);
      this.style.setProperty('--p', p.toFixed(4));
      this.style.setProperty('--q', q.toFixed(4));
      this.style.setProperty('--f', (1 - out * out).toFixed(4));
    }
  }

  if (!customElements.get('lm-immersive-hero')) customElements.define('lm-immersive-hero', LmImmersiveHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-product-grid"] && !Shopify.designMode) return;
  try {
    
  /* A tile may carry a moving view of the piece. It is fetched only when the grid nears the
     viewport and paused again the moment it leaves, so a page of grids decodes nothing it
     is not showing. */
  class LmProductGrid extends HTMLElement {
    connectedCallback() {
      const films = Array.from(this.querySelectorAll('.lm-product-grid__film'));
      if (!films.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const start = (film) => {
        if (!film.getAttribute('src')) {
          film.src = film.dataset.src;
          film.preload = 'auto';
        }
        film
          .play()
          .then(() => film.classList.add('is-playing'))
          .catch(() => {
            window.addEventListener('pointerdown', () => start(film), { once: true, passive: true });
          });
      };

      if (!('IntersectionObserver' in window)) {
        films.forEach(start);
        return;
      }
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) start(entry.target);
            else entry.target.pause();
          });
        },
        { rootMargin: '200px 0px', threshold: 0.1 }
      );
      films.forEach((film) => this.io.observe(film));
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }
  }

  if (!customElements.get('lm-product-grid')) customElements.define('lm-product-grid', LmProductGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-reel"] && !Shopify.designMode) return;
  try {
    
  class LmReel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      this.prev = this.querySelector('[ref="prev"]');
      this.next = this.querySelector('[ref="next"]');
      this.items = Array.from(this.querySelectorAll('.lm-reel__item'));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.ticking = false;

      this.prev?.addEventListener('click', () => this.scrollByTiles(-1));
      this.next?.addEventListener('click', () => this.scrollByTiles(1));
      this.track?.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      if (this.track) this.resizeObserver.observe(this.track);
      this.updateArrows();
      this.armReveal();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.inTrack?.disconnect();
      this.inView?.disconnect();
    }

    step() {
      const first = this.items[0];
      if (!first || !this.track) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    scrollByTiles(direction) {
      if (!this.track) return;
      this.track.scrollBy({ left: direction * this.step(), behavior: this.reduced.matches ? 'auto' : 'smooth' });
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.updateArrows();
      });
    }

    updateArrows() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }

    armReveal() {
      const showAll = () => this.items.forEach((item) => item.classList.add('is-in'));
      if (this.reduced.matches || !('IntersectionObserver' in window) || !this.track) {
        showAll();
        return;
      }

      this.inTrack = new IntersectionObserver(
        (entries) => {
          let index = 0;
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.style.setProperty('--lm-reveal-index', String(index++));
            entry.target.classList.add('is-in');
            this.inTrack?.unobserve(entry.target);
          }
        },
        { root: this.track, threshold: 0.15 }
      );

      // Only start watching the track once the reel itself has scrolled into view.
      this.inView = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.items.forEach((item) => this.inTrack?.observe(item));
          this.inView?.disconnect();
        },
        { threshold: 0.15 }
      );
      this.inView.observe(this);

      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) showAll();
      });
    }
  }

  if (!customElements.get('lm-reel')) customElements.define('lm-reel', LmReel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-world-reel"] && !Shopify.designMode) return;
  try {
    
  class LmWorldReel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      if (!this.track) return;
      this.prev = this.querySelector('[ref="prev"]');
      this.next = this.querySelector('[ref="next"]');
      this.rail = this.querySelector('[ref="rail"]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = parseFloat(this.dataset.speed) || 22;

      this.prev?.addEventListener('click', () => this.nudge(-1));
      this.next?.addEventListener('click', () => this.nudge(1));

      this.films();

      const originals = this.querySelectorAll('.lm-world-reel__item:not(.lm-world-reel__item--clone)');
      if (this.reduced.matches || originals.length < 2) return;

      /* The clones only earn their place once the drift is running. */
      this.classList.add('lm-world-reel--looping');
      this.pos = 0;
      this.carry = 0;
      this.held = false;
      this.idleUntil = 0;

      /*
       * Taking hold of the reel pauses the drift rather than ending it: the point of this section
       * is that it moves on its own, so it picks up again once the visitor has let go. A deliberate
       * scroll or swipe buys a few seconds of quiet; hovering or tabbing in holds it until they leave.
       */
      this.addEventListener('pointerenter', () => { this.held = true; });
      this.addEventListener('pointerleave', () => { this.held = false; });
      this.addEventListener('focusin', () => { this.held = true; });
      this.addEventListener('focusout', () => { this.held = false; });
      ['wheel', 'touchstart', 'pointerdown'].forEach((name) =>
        this.addEventListener(name, () => { this.idleUntil = performance.now() + 2500; }, { passive: true })
      );

      /* A scroll we did not write is the visitor moving the reel; take their position as the truth. */
      this.track.addEventListener(
        'scroll',
        () => {
          if (Math.abs(this.track.scrollLeft - this.pos) > 2) this.pos = this.track.scrollLeft;
          this.paint();
        },
        { passive: true }
      );

      this.measure();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.measure());
        this.ro.observe(this.track);
      }

      /* Nothing moves while the section is off screen. */
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          ([entry]) => {
            this.visible = entry.isIntersecting;
            if (this.visible) this.run();
            else this.stop();
          },
          { threshold: 0.05 }
        );
        this.io.observe(this);
      } else {
        this.visible = true;
        this.run();
      }
    }

    disconnectedCallback() {
      this.stop();
      this.io?.disconnect();
      this.ro?.disconnect();
      this.filmIo?.disconnect();
    }

    /* The distance from the first tile to its clone: one full set, and so one full cycle. */
    measure() {
      const first = this.querySelector('.lm-world-reel__item');
      const clone = this.querySelector('.lm-world-reel__item--clone');
      this.loop = first && clone ? clone.offsetLeft - first.offsetLeft : 0;
    }

    step() {
      const item = this.querySelector('.lm-world-reel__item');
      if (!item) return 1;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    /* An arrow adds a tile's worth of travel, which the frame loop eases off over the next moment. */
    nudge(direction) {
      this.idleUntil = performance.now() + 2500;
      if (!this.loop) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({
          left: Math.max(0, Math.min(this.track.scrollLeft + direction * this.step(), max)),
          behavior: this.reduced.matches ? 'auto' : 'smooth',
        });
        return;
      }
      this.carry += direction * this.step();
      this.run();
    }

    run() {
      if (this.raf || this.reduced.matches) return;
      this.last = null;
      this.raf = requestAnimationFrame((now) => this.frame(now));
    }

    stop() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
      this.last = null;
    }

    frame(now) {
      this.raf = null;
      if (!this.visible || !this.loop) return;

      const elapsed = this.last == null ? 0 : Math.min((now - this.last) / 1000, 0.1);
      this.last = now;

      /* An arrow's travel is spent first and eases out; the steady drift runs underneath it. */
      if (Math.abs(this.carry) > 0.4) {
        const move = this.carry * 0.14;
        this.pos += move;
        this.carry -= move;
      } else {
        this.carry = 0;
        if (!this.held && now >= this.idleUntil) this.pos += this.speed * elapsed;
      }

      this.pos = ((this.pos % this.loop) + this.loop) % this.loop;
      this.track.scrollLeft = this.pos;
      this.paint();
      this.raf = requestAnimationFrame((next) => this.frame(next));
    }

    paint() {
      if (!this.rail) return;
      const span = this.loop || this.track.scrollWidth - this.track.clientWidth;
      if (span <= 0) return;
      /* The rail reads as a window on the whole reel: as wide a slice as the stage shows, slid
         along by however far through one cycle the reel has run. */
      const slice = Math.max(0.12, Math.min(1, this.track.clientWidth / (this.loop || this.track.scrollWidth)));
      const at = Math.min(1, (this.loop ? this.pos : this.track.scrollLeft) / span);
      this.rail.style.width = `${slice * 100}%`;
      this.rail.style.transform = `translateX(${at * ((1 - slice) / slice) * 100}%)`;
    }

    /* A tile may carry a film. It is fetched only once that tile is near the viewport, and paused
       again the moment it leaves, so a reel of several films decodes at most the ones on screen. */
    films() {
      const films = Array.from(this.querySelectorAll('.lm-world-reel__film'));
      if (!films.length || this.reduced.matches) return;
      const start = (film) => {
        if (!film.getAttribute('src')) {
          film.src = film.dataset.src;
          film.preload = 'auto';
        }
        film
          .play()
          .then(() => film.classList.add('is-playing'))
          .catch(() => {
            window.addEventListener('pointerdown', () => start(film), { once: true, passive: true });
          });
      };
      if (!('IntersectionObserver' in window)) {
        films.forEach(start);
        return;
      }
      this.filmIo = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) start(entry.target);
            else entry.target.pause();
          });
        },
        { rootMargin: '200px 0px', threshold: 0.1 }
      );
      films.forEach((film) => this.filmIo.observe(film));
    }
  }

  if (!customElements.get('lm-world-reel')) customElements.define('lm-world-reel', LmWorldReel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
